import { api, tr } from './shared';

export function getBookingSections(lang) {
  const base = `${api.appHost}/public/booking`;
  return [
    {
      id: 'booking-overview',
      category: tr(lang, 'Онлайн-запись', 'Online booking'),
      navGroup: tr(lang, 'Онлайн-запись', 'Online booking'),
      navGroupOrder: 50,
      navOrder: 0,
      navLabel: tr(lang, 'Обзор', 'Overview'),
      title: tr(lang, 'Public booking API — обзор', 'Public booking API — overview'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Публичная онлайн-запись без JWT: доступ по public_slug страницы. Хост API — app.loyalclub.ru. Виджеты обычно на booking.loyalclub.ru / ddbooking.loyalclub.ru.',
            'Public online booking without JWT: access by page public_slug. API host — app.loyalclub.ru. Widgets usually on booking.loyalclub.ru / ddbooking.loyalclub.ru.',
          ),
        },
        { type: 'list', title: 'Base URL', items: [base] },
        {
          type: 'list',
          title: tr(lang, 'Rate limits (ориентир)', 'Rate limits (approx.)'),
          items: [
            tr(lang, 'Чтение: ~120/min с IP', 'Reads: ~120/min per IP'),
            tr(lang, 'Book: ~20/min, телефон ~8/час', 'Book: ~20/min, phone ~8/hour'),
            tr(lang, 'Manage: ~30–60/min', 'Manage: ~30–60/min'),
          ],
        },
      ],
    },
    {
      id: 'booking-page',
      category: tr(lang, 'Онлайн-запись', 'Online booking'),
      navGroup: tr(lang, 'Онлайн-запись', 'Online booking'),
      navGroupOrder: 50,
      navSubgroup: tr(lang, 'Публичные методы', 'Public methods'),
      navSubgroupOrder: 10,
      navOrder: 10,
      navLabel: 'GET /{slug}',
      title: 'GET /public/booking/{slug}',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Конфиг страницы: организация, услуги, сотрудники, филиалы, form_config. Только enabled + совпадающий public_slug, иначе 404. Кэш ~45s.',
            'Page config: organization, services, staff, branches, form_config. Only enabled + matching public_slug, else 404. Cache ~45s.',
          ),
        },
        {
          type: 'code',
          title: 'curl',
          key: 'booking-page',
          value: `curl -X GET "${base}/<PUBLIC_SLUG>"`,
        },
      ],
    },
    {
      id: 'booking-availability',
      category: tr(lang, 'Онлайн-запись', 'Online booking'),
      navGroup: tr(lang, 'Онлайн-запись', 'Online booking'),
      navGroupOrder: 50,
      navSubgroup: tr(lang, 'Публичные методы', 'Public methods'),
      navSubgroupOrder: 10,
      navOrder: 20,
      navLabel: 'GET .../availability',
      title: 'GET /public/booking/{slug}/availability',
      blocks: [
        {
          type: 'list',
          title: tr(lang, 'Query', 'Query'),
          items: ['date (required)', 'staff_uuid', 'product_uuid', 'branch_id'],
        },
        {
          type: 'text',
          value: tr(lang, 'Слоты с учётом занятости и правил. Кэш ~20s.', 'Slots considering occupancy and rules. Cache ~20s.'),
        },
        {
          type: 'code',
          title: 'curl',
          key: 'booking-avail',
          value: `curl -X GET "${base}/<PUBLIC_SLUG>/availability?date=2026-08-10&product_uuid=<PRODUCT_UUID>"`,
        },
        {
          type: 'list',
          title: tr(lang, 'Смежный метод', 'Related'),
          items: ['GET /public/booking/{slug}/options?scheduled_at=&…'],
        },
      ],
    },
    {
      id: 'booking-book',
      category: tr(lang, 'Онлайн-запись', 'Online booking'),
      navGroup: tr(lang, 'Онлайн-запись', 'Online booking'),
      navGroupOrder: 50,
      navSubgroup: tr(lang, 'Публичные методы', 'Public methods'),
      navSubgroupOrder: 10,
      navOrder: 30,
      navLabel: 'POST .../book',
      title: 'POST /public/booking/{slug}/book',
      blocks: [
        {
          type: 'list',
          title: tr(lang, 'Обязательные поля', 'Required fields'),
          items: ['staff_uuid', 'product_uuid', 'scheduled_at (ISO)', 'client_name', 'phone'],
        },
        {
          type: 'list',
          title: tr(lang, 'Опционально', 'Optional'),
          items: [
            'comment',
            'branch_id',
            'source: online_booking|direct|widget|qr|yandex_maps|social',
            'last_name, email, birthday, preferred_channel, marketing_consent',
          ],
        },
        {
          type: 'code',
          title: 'curl',
          key: 'booking-book',
          value: `curl -X POST "${base}/<PUBLIC_SLUG>/book" \\\n  -H "Content-Type: application/json" \\\n  -d '{\n    "staff_uuid": "<STAFF_UUID>",\n    "product_uuid": "<PRODUCT_UUID>",\n    "scheduled_at": "2026-08-10T12:00:00+03:00",\n    "client_name": "Иван",\n    "phone": "+79990001122",\n    "source": "widget"\n  }'`,
        },
        {
          type: 'code',
          title: tr(lang, 'Ответ', 'Response'),
          key: 'booking-book-resp',
          value: `{\n  "ok": true,\n  "appointment_uuid": "...",\n  "manage_token": "...",\n  "scheduled_at": "...",\n  "duration_minutes": 60,\n  "price": 150000,\n  "confirmation_status": "...",\n  "payment_status": "unpaid"\n}`,
        },
      ],
    },
    {
      id: 'booking-manage',
      category: tr(lang, 'Онлайн-запись', 'Online booking'),
      navGroup: tr(lang, 'Онлайн-запись', 'Online booking'),
      navGroupOrder: 50,
      navSubgroup: tr(lang, 'Self-service', 'Self-service'),
      navSubgroupOrder: 20,
      navOrder: 10,
      navLabel: '/manage/{token}',
      title: 'GET|POST /public/booking/manage/{token}',
      blocks: [
        {
          type: 'list',
          title: tr(lang, 'Методы', 'Methods'),
          items: [
            'GET /public/booking/manage/{token}',
            'POST /public/booking/manage/{token}/cancel',
            'POST /public/booking/manage/{token}/reschedule  { scheduled_at, staff_uuid? }',
          ],
        },
        {
          type: 'text',
          value: tr(
            lang,
            'manage_token выдаётся при book. Cancel/reschedule зависят от настроек self_service и лимита часов.',
            'manage_token is issued on book. Cancel/reschedule depend on self_service settings and hour limits.',
          ),
        },
      ],
    },
  ];
}
